<template>
  <div id="all">
    <div id="ajax-upload">
      <main id="main">
        <div class="container">
          <div class="auth-box">
            <div class="logo">
              <icon-logo/>
            </div>
            <div class="auth-form">
              <p class="h2 title line">Login</p>
              <form action="#" class="form">
                <div class="field">
                  <label class="field-name">Email</label>
                  <input type="text" class="form-control" placeholder="Your user name" v-model="login" v-on:keydown.enter.prevent="loginClick" @blur="checkInputs" @keydown="errorMessage=''">
                </div>
                <div class="field">
                  <label class="field-name">Password</label>
                  <input type="password" class="form-control" placeholder="Your password" v-model="password" v-on:keydown.enter.prevent="loginClick" @blur="checkInputs" @keydown="errorMessage=''">
                </div>
                <p style="color: red">{{errorMessage}}</p>
                <div class="link-box">
                  <router-link to="/request" class="link js-ajax-link">Forgot password</router-link>
                </div>
                <div class="form-btn-box">
                  <button type="button" class="btn success small" @click.prevent="loginClick" :disabled="loading">
                    <icon-base width="21" height="21" viewBox="0 0 21 21" icon-name="Login" v-if="!loading"><icon-door/></icon-base>
                    <span>{{loading ? 'Login...' : 'Login'}}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
    </div>

  </div>
</template>

<script>

import {mapMutations, mapActions, mapGetters, mapState} from 'vuex'
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import IconBase from "./common/IconBase";
import IconDoor from "./common/icons/IconDoor";
import IconLogo from "./common/icons/IconLogo";


export default {
    name: 'Login',
    components: {IconLogo, IconDoor, IconBase},
    props: {},
    setup () {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            token: '',
            login: '',
            password: '',
            errorMessage: '',
            loading: false

        }
    },
    validations() {
        return {
            login: {required},
            password: {required},
        }
    },
    created() {
        if (this.isAuthenticated) {
            this.$router.push('/')
        }
    },
    mounted () {
        document.body.classList.add('auth-page')
    },
    unmounted () {
        document.body.classList.remove('auth-page')
    },
    computed: {
        ...mapGetters('user', [
            'isAuthenticated',
        ]),
        ...mapState('user', [
          'roles'
        ]),
    },
    methods: {
        ...mapMutations('user', [
            'setUser'
        ]),
        ...mapMutations([
          'setFirstLoading',
          'setLoading'
        ]),
        ...mapActions('user', [
            'authUser',
            'getUserInfo'
        ]),
        checkInputs() {
            this.v$.$touch();
            if (this.v$.password.$errors.length && this.v$.password.$errors[0].$validator === 'required') {
                this.errorMessage = 'Password are empty';
            }
            if (this.v$.login.$errors.length && this.v$.login.$errors[0].$validator === 'required') {
                this.errorMessage = 'Username are empty';
            }
        },
        loginClick() {
            this.checkInputs();
            if (!this.v$.$invalid) {

                this.loading = true;

                let params = {
                    username: this.login,
                    password: this.password
                };

                this.authUser(params).then(() => {
                    this.loading = false;
                    this.setFirstLoading(true);
                    this.getUserInfo().then(() => {
                      if (this.roles.includes('manager') || this.roles.includes('dev')){
                        this.$router.push('/manage/requests')
                      }
                      else if (this.roles.includes('admin') || this.roles.includes('admin')){
                        this.isCustomer = false
                      } else  {
                        this.$router.push({name: 'ClientApp'});
                      }
                    });
                }).catch((message) => {
                    this.errorMessage = message;
                    this.loading = false;
                });

            }
        },
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
